import React from "react";
import { withTranslation } from "react-i18next";
import images from "ressources/images";

import "../FiltersMenuItem/FiltersMenuItem.scss";

const FiltersDataContent = ({
  data,
  filters,
  setfilters,
  filter,
  name,
  id,
}) => {
  // Remove element from state if it is already in it,
  // or add it
  const handleChange = (event) => {
    const { name } = event.target;

    if (filters[filter].includes(name)) {
      const tmp = [...filters[filter]];
      const index = tmp.indexOf(name);

      tmp.splice(index, 1);
      setfilters({ ...filters, [filter]: tmp });
    } else {
      setfilters({
        ...filters,
        [filter]: [...filters[filter], name],
      });
    }
  };

  return (
    <div>
      {data &&
        data.map((item) => (
          <div className="item_row" key={item[id]}>
            <input
              checked={filters[filter].includes(item[id].toString())}
              type="checkbox"
              name={item[id]}
              id={item[name]}
              onChange={(e) => handleChange(e)}
            />
            <label htmlFor={item[name]}>
              <div>{item[name]}</div>
              <img alt="valid" src={images.checked_black}></img>
            </label>
          </div>
        ))}
    </div>
  );
};

export default withTranslation("global")(FiltersDataContent);
